var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 15 16", fill: "none" }, props),
    React.createElement("path", { d: "M4.535 3.3h-2.35a1.437 1.437 0 0 0 0 2.874h2.35M10.305 3.3h2.35a1.437 1.437 0 0 1 0 2.874h-2.35", stroke: "#fff" }),
    React.createElement("path", { d: "M1.854 14.5v.974h11.132V14.5h-.253a4.605 4.605 0 0 1-4.607-4.604H6.712a4.605 4.605 0 0 1-4.605 4.604h-.253z", fill: "#fff" }),
    React.createElement("path", { d: "M7.441 9.926a3.95 3.95 0 0 1-3.896-3.298L2.885.903h9.111l-.661 5.725A3.95 3.95 0 0 1 7.44 9.926z", fill: "#fff" })
  );
});